import { render, staticRenderFns } from "./IntegratedModelDetail.vue?vue&type=template&id=2af1c956&scoped=true"
import script from "./IntegratedModelDetail.vue?vue&type=script&lang=js"
export * from "./IntegratedModelDetail.vue?vue&type=script&lang=js"
import style0 from "./IntegratedModelDetail.vue?vue&type=style&index=0&id=2af1c956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1c956",
  null
  
)

export default component.exports